<template>
  <div class="content-container">
    <search-comp @onSearch="onSearch" @onReset="onResetSearch">
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-row">
            <div class="das-form-col col-4">
              <div class="das-form-input">
                <div class="label">
                  {{ 'Khoảng ngày' }}
                </div>
                <div class="">
                  <CalendarRange v-model="searchParams.date" mode="date" />
                </div>
              </div>
            </div>

            <div class="das-form-col col-4">
              <div class="das-form-input">
                <div class="label">
                  {{ 'Trạng thái phòng đoàn' }}
                </div>
                <div class="">
                  <el-select
                    v-model="searchParams.type"
                    placeholder="Vui lòng chọn"
                  >
                    <el-option
                      v-for="item in typeOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>
            </div>

            <div class="das-form-col col-4">
              <div class="das-form-input">
                <div class="label">
                  <!-- {{ 'Người' }} -->
                  {{ 'Lễ tân' }}
                </div>
                <div class="">
                  <select-with-search-table
                    style="width: 100%"
                    index-field="id"
                    :search-fields="['code', 'name']"
                    :selected-index-field-value="searchParams.salePersonId"
                    :value="searchParams.salePersonId"
                    :rows="salePersonRows"
                    :columns="salePersonCols"
                    :dropdown-width="400"
                    :is-remove-btn="true"
                    @selectionChanged="onSelectSalePerson"
                  >
                    <template v-slot:value="{ selectedValue: selectedData }">
                      <div>
                        <span>
                          {{
                            `${selectedData?.code || ''} - ${
                              selectedData?.full_name || ''
                            }`
                          }}
                        </span>
                      </div>
                    </template>
                  </select-with-search-table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </search-comp>

    <div class="content-box">
      <div class="section-box outline">
        <div class="das-form-container">
          <div class="das-form-title-container" style="display: flex">
            <div class="das-form-title">
              <span class="main-title">
                {{ `Báo cáo giữ phòng đoàn` }}
              </span>
            </div>

            <DownloadBtn @openNoteDialog="dialogNoteVisibleKeep = true" />
          </div>
          <hr />

          <div class="grid-scroll mt-10">
            <GridVx
              ref="agGrid"
              :columns="columnsKeep"
              :rows="rowsKeep"
              class="agGrid"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="content-box mt-20">
      <div class="section-box outline">
        <div class="das-form-container">
          <div class="das-form-title-container" style="display: flex">
            <div class="das-form-title">
              <span class="main-title">
                {{ `Báo cáo hủy phòng đoàn` }}
              </span>
            </div>

            <DownloadBtn @openNoteDialog="dialogNoteVisibleCancel = true" />
          </div>
          <hr />

          <div class="grid-scroll mt-10">
            <GridVx
              ref="agGrid"
              :columns="columnsCancel"
              :rows="rowsCancel"
              class="agGrid"
            />
          </div>
        </div>
      </div>
    </div>

    <NoteDialog v-model="dialogNoteVisibleKeep">
      <div class="das-form-container">
        <div class="das-form-group">
          <ul class="annotate-container">
            <li>
              - Giữ: Bảng hiển thị danh sách các phòng đang được giữ khi khách
              đã cọc hoặc chưa cọc và dự kiến ngày hủy phòng và thông tin. Bao
              gồm các trường
            </li>
            <li>+ Recode: Hiển thị mã đặt phòng</li>
            <li>+ Phòng: Hiển thị số phòng</li>
            <li>+ Tên khách: Hiển thị tên khách chính đặt phòng</li>
            <li>
              + Ngày đặt: Hiển thị ngày đặt trên hệ thống. Format DDMMYYYY
            </li>
            <li>
              + Dự kiến đến: Hiển thị ngày khách dự kiến đến. Format DDMMYYYY
            </li>
            <li>
              + Lễ tân: Hiển thị họ và tên nhân viên lễ tân thực hiện đặt phòng
              cho khách
            </li>
            <li>
              + Ngày bắt đầu giữ: Hiển thị ngày bắt đầu giữ phòng cho khách
            </li>
            <li>
              + Ngày cọc: Hiển thị ngày thực hiện cọc tiền cho khách. Nếu khách
              chưa cọc không hiển thị dữ liệu. Format: DDMMYYYY HHMM
            </li>
            <li>+ Trạng thái: Hiển thị bao gồm 2 trường:</li>
            <li>- Giữ phòng: Hiển thị số ngày đã giữ phòng cho khách</li>
            <li>
              - Hủy phòng: Hiển thị ngày hủy phòng dự kiến của đặt phòng nếu
              khách hàng không thực hiện cọc
            </li>
          </ul>
        </div>
      </div>
    </NoteDialog>
    <NoteDialog v-model="dialogNoteVisibleCancel">
      <div class="das-form-container">
        <div class="das-form-group">
          <ul class="annotate-container">
            <li>
              - Hủy: Bảng hiển thị danh sách các phòng đã bị hủy khi khách không
              đặt cọc hoặc có vấn đề phải hủy phòng
            </li>
            <li>+ Recode: Hiển thị mã đặt phòng</li>
            <li>+ Phòng: Hiển thị số phòng</li>
            <li>+ Tên khách: Hiển thị tên khách chính đặt phòng</li>
            <li>
              + Ngày đặt: Hiển thị ngày đặt trên hệ thống. Format DDMMYYYY
            </li>
            <li>
              + Dự kiến đến: Hiển thị ngày khách dự kiến đến. Format DDMMYYYY
            </li>
            <li>
              + Lễ tân: Hiển thị họ và tên nhân viên lễ tân thực hiện đặt phòng
              cho khách
            </li>
            <li>
              + Ngày bắt đầu giữ: Hiển thị ngày bắt đầu giữ phòng cho khách
            </li>
            <li>
              + Ngày cọc: Hiển thị ngày thực hiện cọc tiền cho khách. Nếu khách
              chưa cọc không hiển thị dữ liệu. Format: DDMMYYYY HHMM
            </li>
            <li>
              + Trạng thái: Hiển thị trạng thái phòng đã được đẩy về trạng thái
              có thể bán
            </li>
            <li>
              + Thời gian hủy: Hiển thị thời gian thực hiện hủy đặt phòng.
              Format: DDMMYYYY HHMM
            </li>
            <li>+ Thao tác bởi:</li>
            <li>- Nếu người hủy: Tên người hủy</li>
            <li>- Nếu hệ thống hủy: hệ thống hủy do hết hạn ngày giữ</li>
          </ul>
        </div>
      </div>
    </NoteDialog>
  </div>
</template>

<script>
import CalendarRange from '@/components/CalendarSelect/CalendarRange.vue'
import DownloadBtn from './components/DownloadBtn.vue'
import NoteDialog from './components/NoteDialog.vue'

import { getAccount } from '@/api/reception/common'
import { getKeepCancelRoomReport } from '@/api/report_service/datntReport'

export default {
  components: { CalendarRange, DownloadBtn, NoteDialog },
  data() {
    return {
      searchParams: {
        date: {
          start: this.$moment().format('YYYY-MM-DD'),
          end: this.$moment().format('YYYY-MM-DD')
        },
        type: null,
        dateFrom: null,
        dateTo: null,
        salePersonId: null,
        hotelId: []
      },
      defaultSearchParams: {
        date: {
          start: this.$moment().format('YYYY-MM-DD'),
          end: this.$moment().format('YYYY-MM-DD')
        },
        type: null,
        dateFrom: null,
        dateTo: null,
        salePersonId: null,
        hotelId: []
      },

      typeOptions: [
        {
          label: 'Chọn tất cả',
          value: null
        },
        {
          label: 'Hủy',
          value: 2
        },
        {
          label: 'Giữ',
          value: 1
        }
      ],

      // data for search
      salePersonRows: [],
      salePersonCols: [
        {
          headerName: 'Tên',
          field: 'full_name',
          minWidth: 120,
          maxWidth: 150
        },
        {
          headerName: 'Code',
          field: 'code',
          // tooltipFiled: 'desc',
          flex: 1
        }
      ],

      // grid
      columnsKeep: [
        {
          headerName: 'Recode',
          field: 'recode',
          headerClass: 'header-row-span-2'
        },
        {
          headerName: 'Phòng',
          field: 'room_num',
          headerClass: 'header-row-span-2'
        },
        {
          headerName: 'Tên khách',
          field: '',
          headerClass: 'header-row-span-2',
          valueGetter: params =>
            `${params.data.first_name} ${params.data.last_name}`
        },
        {
          headerName: 'Ngày đặt',
          field: 'booking_date',
          headerClass: 'header-row-span-2'
        },
        {
          headerName: 'Dự kiến đến',
          field: 'arrive_date',
          headerClass: 'header-row-span-2'
        },
        {
          headerName: 'Lễ tân',
          field: 'sale_person_nm',
          headerClass: 'header-row-span-2'
        },
        {
          headerName: 'Ngày bắt đầu giữ',
          field: 'start_date_hold',
          headerClass: 'header-row-span-2'
        },
        {
          headerName: 'Ngày cọc',
          field: 'deposit_date',
          headerClass: 'header-row-span-2'
        },
        {
          headerName: 'Trạng thái',
          children: [
            { headerName: 'Giữ phòng', field: 'num_of_days_keep_room' },
            {
              headerName: 'Hủy phòng',
              field: 'cancel_date',
              headerClass: 'last-header-cell-group'
            }
          ]
        }
      ],
      columnsCancel: [
        { headerName: 'Recode', field: 'recode' },
        { headerName: 'Phòng', field: 'room_num' },
        {
          headerName: 'Tên khách',
          field: '',
          valueGetter: params =>
            `${params.data.first_name} ${params.data.last_name}`
        },
        { headerName: 'Ngày đặt', field: 'booking_date' },
        { headerName: 'Dự kiến đến', field: 'arrive_date' },
        { headerName: 'Lễ tân', field: 'sale_person_nm' },
        { headerName: 'Ngày bắt đầu giữ', field: 'start_date_hold' },
        { headerName: 'Ngày cọc', field: 'deposit_date' },
        { headerName: 'Trạng thái', field: 'status' },
        { headerName: 'Thời gian hủy', field: 'cancel_date' },
        { headerName: 'Thao tác bởi', field: 'sale_cancel_nm' }
      ],
      rowsKeep: [],
      rowsCancel: [],

      // dialog
      dialogNoteVisibleKeep: false,
      dialogNoteVisibleCancel: false
    }
  },

  async mounted() {
    await this.getListSalePerson()
    await this.fnGetKeepCancelRoomReport()
  },
  methods: {
    onSearch() {
      this.fnGetKeepCancelRoomReport()
    },
    onResetSearch() {
      this.searchParams = { ...this.defaultSearchParams }
      this.fnGetKeepCancelRoomReport()
    },

    onSelectSalePerson(selected) {
      this.searchParams.salePersonId = selected?.id
    },

    // handle api call
    async getListSalePerson() {
      // Le tan
      const res = await getAccount({ department: 'FO' })
      this.salePersonRows = res.data.map(item => {
        return {
          id: item.account.id,
          code: item.account.code,
          full_name: item.account.full_name
        }
      })
    },
    async fnGetKeepCancelRoomReport() {
      try {
        const query = {
          type: this.searchParams.type,
          dateFrom: this.searchParams.date.start,
          dateTo: this.searchParams.date.end,
          salePersonId: this.searchParams.salePersonId
        }
        const res = await getKeepCancelRoomReport(query)
        this.rowsCancel = res.map?.cancel
        this.rowsKeep = res.map?.keep
      } catch (error) {
        this.$message({
          type: 'error',
          message: this.$t(
            'errorMsg.' + error?.response?.data?.message
              ? error?.response?.data?.message
              : error
          )
        })
      } finally {
        //
      }
    }
  }
}
</script>

<style></style>
